/**
 * DADD'E - product page sale tag.
 * Runs ONLY on /products/ pages, for items in the SALE list, and only while
 * DADDE_SALE.enabled is true.
 *
 * Live mode: the red '% OFF' tag is added only when Shopify is already
 * rendering a compare-at price for the product, which the theme emits solely
 * when compare_at_price > price. Before the real sale prices are written, and
 * after they are restored, the product page is left completely untouched. A
 * customer can never be shown a discount the checkout will not honour.
 *
 * Preview mode: add ?dadde_preview=1 to the URL to see the tag and the
 * simulated sale price as they will look once the real prices are live.
 * No link on the site carries that parameter.
 *
 * The discount map and the enabled switch live in dadde-sale-map.js.
 */
(function () {
  var CFG = window.DADDE_SALE;
  if (!CFG || CFG.enabled === false) return;
  var DISCOUNTS = CFG.discounts;

  var PREVIEW = /[?&]dadde_preview=1/.test(window.location.search);

  function currentHandle() {
    var path = window.location.pathname;
    var idx = path.indexOf('/products/');
    if (idx === -1) return null;
    return path.slice(idx + 10).split('/')[0].split('?')[0];
  }

  function addPreviewFlag() {
    if (!PREVIEW) return;
    if (document.getElementById('dadde-preview-flag')) return;
    if (!document.body) return;
    var flag = document.createElement('div');
    flag.id = 'dadde-preview-flag';
    flag.textContent = 'Preview';
    flag.style.cssText = 'position:fixed;inset-inline-start:14px;inset-block-end:14px;z-index:9999;background:#111;color:#fff;padding:8px 12px;border-radius:3px;font-size:10px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;box-shadow:0 2px 10px rgba(0,0,0,.25);pointer-events:none;';
    var sub = document.createElement('em');
    sub.textContent = 'Simulated prices - not live';
    sub.style.cssText = 'display:block;margin-block-start:3px;font-style:normal;font-weight:400;letter-spacing:.04em;text-transform:none;opacity:.7;';
    flag.appendChild(sub);
    document.body.appendChild(flag);
  }

  function decorate(discount) {
    addPreviewFlag();
    if (document.querySelector('[data-dadde-product-sale]')) return;

    /* Proof that Shopify itself is discounting this product. */
    var themeShowsSale = !!document.querySelector('.compare-at-price');
    if (!themeShowsSale && !PREVIEW) return;

    var priceEl = document.querySelector('product-information .price')
      || document.querySelector('.product-information .price')
      || document.querySelector('main .price')
      || document.querySelector('.price');
    if (!priceEl || !priceEl.parentNode) return;

    var wrap = document.createElement('span');
    wrap.setAttribute('data-dadde-product-sale', '1');
    wrap.style.cssText = 'display:inline-flex;align-items:center;gap:10px;margin-inline-start:10px;vertical-align:baseline;';

    var badge = document.createElement('span');
    badge.textContent = discount + '% OFF';
    badge.style.cssText = 'background:#e2231a;color:#ffffff;padding:4px 9px;border-radius:2px;font-size:11px;font-weight:700;letter-spacing:.06em;white-space:nowrap;';
    wrap.appendChild(badge);

    /* PREVIEW ONLY - never for a real visitor, never once the price is genuine. */
    if (!themeShowsSale && PREVIEW) {
      var text = (priceEl.textContent || '').trim();
      var match = text.match(/[0-9][0-9.,]*/);
      if (!match) return;
      var original = parseFloat(match[0].replace(/,/g, ''));
      if (!(original > 0)) return;

      var sale = original * (100 - discount) / 100;
      var formatted = sale.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var saleText = text.replace(/[0-9][0-9.,]*/, formatted);

      priceEl.style.textDecoration = 'line-through';
      priceEl.style.color = '#9a9a9a';

      var salePriceEl = document.createElement('span');
      salePriceEl.textContent = saleText;
      salePriceEl.style.cssText = 'color:#e2231a;font-weight:600;white-space:nowrap;';
      wrap.appendChild(salePriceEl);
    }

    priceEl.parentNode.insertBefore(wrap, priceEl.nextSibling);
  }

  var scheduled = false;
  function schedule(discount) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      decorate(discount);
    });
  }

  function init() {
    var handle = currentHandle();
    if (!handle) return;
    var discount = DISCOUNTS[handle];
    if (!discount) return;
    decorate(discount);
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () { schedule(discount); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
